<ca-modal-container
    modalTitle="{{ 'GENERAL.FEEDBACK.TITLE' | translate }}"
    description="{{ 'GENERAL.FEEDBACK.DESCRIPTION' | translate }}"
    (dismiss)="dismiss($event)"
>
    <form [formGroup]="feedbackForm" (ngSubmit)="submit()" novalidate>
        <div class="message d-flex flex-column mb-3">
            <label class="mb-2">{{ 'GENERAL.FEEDBACK.EXPERIENCE' | translate }}</label>
            <div class="d-flex">
                <ca-icon
                    *ngFor="let smiley of smileys"
                    [name]="smiley.name"
                    size="l"
                    class="me-3 cursor-pointer"
                    (click)="selectSmiley(smiley)"
                    [ngClass]="{ 'ca-text-primary': smiley.selected }"
                ></ca-icon>
            </div>
        </div>
        <div class="message mt-2 d-flex flex-column-reverse">
            <textarea formControlName="message" class="form-control p-3"></textarea>
            <label>Comment</label>
        </div>
        <div class="d-flex justify-content-between mt-2">
            <ca-input-checkbox formControlName="share_result" class="align-self-center">
                <div class="font-sm share-result-text">
                    {{ 'GENERAL.FEEDBACK.SHARE_RESULT' | translate }}
                </div>
            </ca-input-checkbox>
            <button type="submit" caAutoFocus class="btn btn-primary mt-1">
                {{ 'GENERAL.SEND' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
